var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-container",style:({width: ("" + _vm.width), height: ("" + _vm.height)})},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }